export class Listable {
    public uuid: string;
    public name: string;
    public value: string;

    constructor() {}
}
